{
  "zh-CN": {
    "chart": {
      "labels": {
        "view": {
          "one": "%{label}:<br><b>%{count}</b> 浏览",
          "other": "%{label}:<br><b>%{count}</b> 浏览"
        },
        "ship": {
          "one": "%{label}:<br><b>%{count}</b> 飞船",
          "other": "%{label}:<br><b>%{count}</b> 飞船"
        },
        "ship-pie": {
          "one": "%{label}:<br><b>%{count}</b> 飞船 (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> 飞船 (%{percentage} %)"
        },
        "component-pie": {
          "one": "%{label}:<br><b>%{count}</b> 组件 (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> 组件 (%{percentage} %)"
        },
        "user": {
          "one": "%{label}:<br><b>%{count}</b> 用户",
          "other": "%{label}:<br><b>%{count}</b> 用户"
        },
        "user-pie": {
          "one": "%{label}:<br><b>%{count}</b> User (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> Users (%{percentage} %)"
        },
        "visit": {
          "one": "%{label}:<br><b>%{count}</b> 访问",
          "other": "%{label}:<br><b>%{count}</b> 访问"
        }
      }
    }
  }
}
